export const ZOOM_LEVELS = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0, 3.0]
export const MIN_ZOOM = ZOOM_LEVELS[0]
export const MAX_ZOOM = ZOOM_LEVELS[ZOOM_LEVELS.length - 1]

const ZOOM_FALLBACK_STEP = 0.25

type ZoomDirection = "in" | "out"

export const clampPageNumber = (page: number, totalPages: number) => {
  if (totalPages <= 0) {
    return Math.max(1, page)
  }

  if (page < 1) {
    return 1
  }

  if (page > totalPages) {
    return totalPages
  }

  return page
}

export const getNextZoomLevel = (current: number, direction: ZoomDirection) => {
  const currentIndex = ZOOM_LEVELS.findIndex((level) => level >= current)

  if (direction === "in") {
    if (currentIndex === -1 || currentIndex === ZOOM_LEVELS.length - 1) {
      return Math.min(current + ZOOM_FALLBACK_STEP, MAX_ZOOM)
    }

    return ZOOM_LEVELS[currentIndex + 1] ?? current
  }

  if (currentIndex <= 0) {
    return Math.max(current - ZOOM_FALLBACK_STEP, MIN_ZOOM)
  }

  return ZOOM_LEVELS[currentIndex - 1] ?? current
}
